import { i18nTranslate } from 'src/utils'
import { isB2BAccount } from 'src/utils'
import { userDetailsSchema } from './validationSchema'
import { userDetailsformInput } from './formInput'

export const accountOverviewFormData = async userResponse => {
  const labelValue = isB2BAccount()
    ? i18nTranslate('account.profileInfo', 'Profile Information')
    : i18nTranslate('account.overview', 'Account Overview')
  return {
    label: labelValue,
    schema: userDetailsSchema(userResponse),
    formInput: await userDetailsformInput(userResponse),
    button: {
      label: i18nTranslate('account.saveChanges', 'Save Changes'),
      dataTestId: 'qa-save-changes',
    },
  }
}

export const loyaltyRewardsFormData = {
  label: i18nTranslate('nuskinEnjoyRewards.title', 'Nu Skin Rewards', {
    nameSpace: 'ssr-resource',
  }),
  dataTestId: 'loyalty-rewards',
  offTitle: i18nTranslate(
    'account.loyaltyOffTitle',
    'Would you like to Opt In to Nu Skin Rewards program?'
  ),
  onTitle: i18nTranslate(
    'account.loyaltyOnTitle',
    'You have now Opted in to Nu Skin Rewards program!'
  ),
  optOutTxt: i18nTranslate(
    'account.loyaltyoptOutTxt',
    'Yes, I would like to Opt-in'
  ),
  optInTxt: i18nTranslate('account.loyaltyoptOffTxt', 'Opted In'),
  brandAffiliateUserTxt: i18nTranslate(
    'account.loyaltybrandAffiliateUserTxt',
    'Nu Skin Rewards Program is exclusively for Retail Customers and Members!'
  ),
  buyerUserTxt: i18nTranslate(
    'account.loyaltybuyerUserTxtTxt',
    'You are still not opted in to the Nu Skin Rewards Program. You will automatically be opted in when your Primary User opts in.'
  ),
}
